module.exports = __webpack_public_path__ + "img/drug-15.05f78eb4.png";